import CircularProgress from "@material-ui/core/CircularProgress";
import React from "react";
import "../style";
export default class CircularIndeterminate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: true
    };
  }

  componentDidMount() {
    let timer = 20000;
    setTimeout(() => {
      this.setState({ showLoader: false });
    }, timer);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setState({ showLoader: true });
  }

  render() {
    const { showLoader } = this.state;
    return (
      <div aria-busy="true">
        {showLoader ? (
          <div className="loader">
            <h4>Please wait while we are processing your request...</h4>
            <CircularProgress />
          </div>
        ) : (
          <div className="ErrorMessage" style={{ textAlign: "center" }}>
            <h4>Please refresh your page and check again.</h4>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Loader.js